export default __webpack_public_path__ + "static/media/AW2OCT22.42f4a4fc.jpg";